import React from 'react';
import {Row, Col, Card} from 'antd';
import DocumentMeta from 'react-document-meta';
import {aboutUsMeta} from '../constants/meta';
import {CheckCircleOutlined, ReadOutlined, ReconciliationOutlined} from '@ant-design/icons';
import {CusImage, Section, PageHeader} from '../common'
import ImageSrc from '../img/au.jpg';

const AboutUs = () => {
  return (
    <DocumentMeta {...aboutUsMeta}>
      <PageHeader title="За нас" />
      <Section>
        <Col md={16}>
          <h2>Специализиран сайт за услуги в областта на образованието</h2>
          <p>studentite.com е специализиран сайт за <strong>услуги в областта на образованието</strong> с дългогодишни традиции и опит. Екипът ни предлага професионални услуги в областта на <strong>разработването на теми на магистърски тези</strong>, <strong>дипломни</strong> и <strong>курсови работи</strong>, реферати, есета, казуси, задачи, въпроси, отчети за стажове и др., в икономическата област.</p>
          <p>Предлагаме и професионална помощ при <strong>решаване на тестове</strong> за <strong>изпити</strong> за повечето икономически специалности.</p>
          <p>Тук учениците могат да получат помощ при <strong>решаване на задачи по математика</strong> от първи до дванадесети клас.</p>
          <p>Стотици студенти, кандидат-студенти и ученици са ползвали и ползват нашите услуги, които подпомагат тяхното кандидатстване, следване и завършване при <strong>пълна конфиденциалност</strong> от наша страна.</p>
          <p>Дългогодишният ни опит в тази област ни помага да разберем точните Ви нужди и да се опитаме да Ви помогнем при <strong>написването на Вашите проекти</strong>.</p>
          <p>Гаранцията за <strong>качество</strong>, която Ви даваме, може да Ви вдъхне допълнително увереност в процеса на Вашето обучение.</p>
        </Col>
        <Col style={{margin: "auto"}} xs={20} md={8}>
          <CusImage src={ImageSrc} frameStyle="full" alt="Изготвяне на дипломни работи" />
        </Col>
      </Section>
      <Section style={{paddingTop: 0}}>
        <Col>
          <Card>
            <Row gutter={24}>
              <Col md={8}>
                <CheckCircleOutlined />
                <h4>Казуси</h4>
                <p>Дългогодишния ни опит гарантира <strong>разработката на качествени казуси</strong> за всички икономически специалности за редовно и <strong>дистанционно обучение</strong>, отговарящи на изпратеното от Вас условие.</p>
              </Col>
              <Col md={8}>
                <ReadOutlined />
                <h4>Тестове</h4>
                <p>Предлагаме помощ при <strong>решаване на тестове</strong> за изпити за всички икономически специалности.</p>
              </Col>
              <Col md={8}>
                <ReconciliationOutlined />
                <h4>Математика</h4>
                <p>Предлагаме квалифицирана помощ за <strong>решаване на задачи по математика</strong> за всички ученици от първи до дванадесети клас.</p>
              </Col>
            </Row>
          </Card>
        </Col>
      </Section>
    </DocumentMeta>
  );
};

export default AboutUs;